import ClientTruncate from '@common/components/ClientTruncate';

import { Markdown } from '@common/components';

import Alert from '@common/components/Alert/Alert';
import { GuestCounter } from '@common/components/GuestPicker/GuestCounter';
import { PopperRow } from '@common/components/Popper';
import { ExperienceType } from '@features/DynamicPackagesConfigurationWizard/types';
import { useTranslations } from '@lang';
import { SpaEntityType } from 'shared-types/Spa';
import { TimeSlotType } from 'shared-types/SpaPackage';

import { useState } from 'react';
import {
  GuestCounterWrapper,
  ShowMoreLess,
  SpaDetails,
  SpaDetailsHeadSection,
  SpaDetailsWrapper,
  SpaItemName,
} from './ExperienceDetails.styles';

export type ExperienceDetailsProps = {
  entityType?: ExperienceType;
  id: number;
  language: string;
  propertyId: number;
  isMobile?: boolean;
  count: number;
  plusMinusSpaOption: (
    type: 'plus' | 'minus',
    id: number,
    optionId: number,
    startTime?: string
  ) => void;
  disabledMinus: boolean;
  disabledPlus: boolean;
  optionId: number;
  allOptionsIncluded?: boolean;
  unavailable?: boolean;
  spaEntity?: Partial<SpaEntityType> & { startTime?: string; timeslots?: TimeSlotType[] };
};
export const ExperienceDetails = ({
  id,
  isMobile,
  count,
  plusMinusSpaOption,
  disabledMinus,
  disabledPlus,
  allOptionsIncluded,
  unavailable,
  optionId,
  spaEntity,
}: ExperienceDetailsProps) => {
  const { t } = useTranslations();
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  function toggleShowMore() {
    setIsDescriptionExpanded((val) => !val);
  }

  const unavailableText = t('common.unavailable');

  const spaSummaryMaxLength = 322;
  const spaSummary = spaEntity?.description || '';
  const spaSummaryLongerThanMax = spaSummary.length > spaSummaryMaxLength;

  return (
    <>
      {spaEntity && (
        <>
          <SpaDetailsWrapper>
            <SpaDetailsHeadSection>
              <SpaItemName>{spaEntity?.name}</SpaItemName>
              <SpaDetails>
                {t('spa.minutesIndicator', { number: spaEntity.displayDuration })}
              </SpaDetails>
              <GuestCounterWrapper>
                {unavailable && (
                  <PopperRow>
                    <Alert content={unavailableText} />
                  </PopperRow>
                )}
                {!unavailable && !allOptionsIncluded ? (
                  <GuestCounter
                    count={count}
                    onClickMinus={() => plusMinusSpaOption('minus', Number(id), Number(optionId))}
                    disabledMinus={disabledMinus}
                    disabledPlus={disabledPlus}
                    onClickPlus={() => plusMinusSpaOption('plus', Number(id), Number(optionId))}
                    label="Guests"
                  />
                ) : (
                  <div />
                )}
              </GuestCounterWrapper>
            </SpaDetailsHeadSection>

            {!isMobile && (
              <>
                <SpaDetails>
                  {isDescriptionExpanded ? (
                    <Markdown text={spaEntity.description} />
                  ) : (
                    <ClientTruncate trimWhitespace lines={4}>
                      <Markdown text={spaEntity.description} />
                    </ClientTruncate>
                  )}
                </SpaDetails>
                {spaSummaryLongerThanMax && (
                  <ShowMoreLess onClick={toggleShowMore}>
                    {isDescriptionExpanded ? t('common.readLess') : t('common.readMore')}
                  </ShowMoreLess>
                )}
              </>
            )}
          </SpaDetailsWrapper>
        </>
      )}
    </>
  );
};
